import React, { useContext } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { openUploadModal } from 'components/Layouts/Form/FormBuilder/Content/AddNewContent/uploadModal';
import Button from 'components/shared/Button';
import DropzoneDesc from 'components/shared/FileDropZone/Description';
import useAssetsPermissions from 'hooks/useAssetsPermissions';
import { isOwnerSelector } from 'store/user/selectors';
import { DOCUMENT_MIME_TYPES, MEDIA_MIME_TYPES } from 'utils/asset';

import LandingPageContext from '../../../contexts/LandingPageContext';
import s from './index.module.css';
import { IUploadProps } from './types';

function Upload(props: IUploadProps) {
  const { availableInBasic = false, type, onUpdate, data } = props;
  const dispatch = useDispatch();
  const { page, readOnly, isItinerariesItem = false, landingData } = useContext(LandingPageContext);

  const isOwner = useSelector(isOwnerSelector);
  const currentPage = isItinerariesItem ? landingData : page;
  const uploadModalType = type || 'media';
  const isDocument = uploadModalType === 'document';
  const descText = isDocument ? 'documents' : 'photos';

  const { withAssetSettings } = useAssetsPermissions();

  const getModalTitleText = (type: string) => {
    switch (type) {
      case 'media':
        return 'Add Photos';
      case 'document':
        return 'Add PDF';
      default:
        return 'Add file';
    }
  };

  const getMimeType = (type: string) => {
    switch (type) {
      case 'media':
        return MEDIA_MIME_TYPES;
      case 'document':
        return DOCUMENT_MIME_TYPES;
      default:
        return MEDIA_MIME_TYPES;
    }
  };

  const openModal = async () => {
    const modalTitle = getModalTitleText(uploadModalType);
    // @ts-ignore
    const assets = await openUploadModal(dispatch, {
      type: uploadModalType,
      modalTitle,
      suggested: currentPage,
      isSortingEnabled: true,
      isOwner,
      isItinerariesItem,
      withAssetSettings,
      defaults: {
        name: 'name' in currentPage ? currentPage.name : null,
        tags: 'tags' in currentPage ? currentPage.tags : null,
      },
    });

    if (assets === null) {
      return;
    }

    if (onUpdate) {
      onUpdate({
        ...data,
        availableInBasic,
        data: {
          files: assets,
        },
      });
    }
  };

  if (readOnly) return null;

  return (
    <div className={s.dropzoneWrapper}>
      <DropzoneDesc
        isNoDropzone
        allowedMimeTypes={getMimeType(uploadModalType)}
        placeholder={`Click here to search or upload ${descText}.`}
        headComponent={
          <Button htmlType="button" type="default" onClick={openModal}>
            {getModalTitleText(uploadModalType)}
          </Button>
        }
      />
    </div>
  );
}

export default Upload;
